<template>
    <main class="report__content">
        <div class="wrapper">
            <div class="video">
                <video width="700" controls>
                    <source src="/merck-racer-instruktaz.mp4#t=1" type="video/mp4">
                    Twoja przeglądarka nie wspiera wyświetlania wideo.
                </video>
            </div>

            <Droparea :folder-id="folderId" @updateStatus="updateAttachmentsStatus($event)"/>

            <div v-if="error" class="form__error">{{ error }}</div>

            <div class="form__row form__row--center">
                <a @click="$emit('back', 3)" class="btn btn--blue">Powrót</a>
                <a @click="nextPage" :class="['btn', attachmentsStatus !== 'completed' ? 'btn--disabled' : '']">Dalej</a>
            </div>
        </div>

    </main>
</template>

<script>
import Droparea from "@/components/ui/Droparea";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    name: "Attachments",
    data() {
        return {
            folderId: "",
            attachmentsStatus: '',
            error: "",
        };
    },
    components: {
        Droparea,
    },
    computed: mapGetters({
        securedRequestHeader: "getSecuredRequestHeader",
    }),
    beforeMount() {
        // get the name of the folder to which attachments will be sent
        axios
            .post(`${process.env.VUE_APP_API_URL}/amazon/s3/folder`, {}, {
                headers: this.securedRequestHeader,
            })
            .then((response) => (this.folderId = response.data.id));
    },
    methods: {
        nextPage() {
            switch (this.attachmentsStatus) {
                case 'selected':
                    this.error = "Aby wysłać załączniki wciśnij przycisk \"Rozpocznij przesyłanie\"";
                    break;

                case 'during':
                    this.error = "Zaczekaj aż przesyłanie załączników zostanie zakończone";
                    break;

                case 'completed':
                    this.$emit("next", 5);
                    break;

                default:
                    this.error = "Aby przejść dalej, musisz dodać załącznik";
                    break;
            }
        },
        updateAttachmentsStatus(status) {
            this.error = "";
            this.$emit("updateStatus", status)
            this.attachmentsStatus = status;
        }
    },
};
</script>

<style lang="scss">
.video {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 1.5em;
}
</style>
